import { EPartnerActions } from '@/store/partnersStore/PartnerStoreTypes'

export const partnerFr = {
    api: {
        error: {
            [EPartnerActions.FETCH_PARTNERS]: 'Erreur lors de la récupération des partenaires',
            [EPartnerActions.FETCH_PARTNER]: 'Erreur lors de la récupération du partenaire',
            [EPartnerActions.ADD_PARTNER]: "Erreur lors de l'ajout du partenaire",
            [EPartnerActions.UPDATE_PARTNER]: 'Erreur lors de la modification du partenaire',
            [EPartnerActions.DELETE_PARTNER]: 'Erreur lors de la suppression du partenaire'
        },
        success: {
            [EPartnerActions.FETCH_PARTNERS]:
                'Récupération des partenaires effectuée avec succès !',
            [EPartnerActions.FETCH_PARTNER]: 'Récupération du partenaire effectuée avec succès !',
            [EPartnerActions.ADD_PARTNER]: 'Ajout du partenaire effectuée avec succès !',
            [EPartnerActions.UPDATE_PARTNER]: 'Modification du partenaire effectuée avec succès !',
            [EPartnerActions.DELETE_PARTNER]: 'Suppression du partenaire effectuée avec succès !'
        }
    },
    config: {
        event: "ID de l'évènement",
        checkpoint: 'ID du checkpoint',
        url: 'URL',
        api: 'API'
    },
    line: 'ligne',
    lines: 'lignes',
    total: 'Total'
}
